import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    // ⭐ 根路径动态跳转：未登录→login，已登录→权限第一个页面
    {
        path: '/',
        redirect: () => {
            const token = sessionStorage.getItem("token");
            const userid = sessionStorage.getItem("userid");
            const userPermissions = JSON.parse(sessionStorage.getItem('authInfo') || '[]');

            if (!token || !userid) {
                return '/login';
            }

            // 如果权限列表是路由 name
            if (userPermissions.length > 0) {
                return {
                    name: userPermissions[0]
                };
            }

            // 默认跳首页
            return '/home';
        }
    },

    {
        path: "/login",
        name: "login",
        meta: {
            noAuth: true
        },
        component: () =>
            import("@/views/login/login.vue"),
    },

    {
        path: "/401",
        name: "401",
        meta: {
            noAuth: true
        },
        component: () =>
            import("@/views/error-page/401.vue"),
    },

    {
        path: "/home",
        name: "layout",
        component: () =>
            import("@/layout/MainLayout.vue"),
        children: [{
                path: '/SystemUser',
                name: 'SystemUser',
                meta: {
                    requiredPermission: 'SystemUser'
                },
                component: () =>
                    import('@/views/SystemUserManagement/SystemUser.vue')
            },
            {
                path: '/RightsManagement',
                name: 'RightsManagement',
                meta: {
                    requiredPermission: 'RightsManagement'
                },
                component: () =>
                    import('@/views/SystemUserManagement/RightsManagement.vue')
            },
            {
                path: '/RightsManagement/authorize',
                name: 'authorize',
                meta: {
                    requiredPermission: 'authorize'
                },
                component: () =>
                    import('@/views/SystemUserManagement/authorize.vue')
            },
            {
                path: '/MemberUsers',
                name: 'MemberUsers',
                meta: {
                    requiredPermission: 'MemberUsers'
                },
                component: () =>
                    import('@/views/userList/MemberUsers.vue')
            },
            {
                path: '/MemberUsers/More',
                name: 'MemberUsersMore',
                meta: {
                    requiredPermission: 'MemberUsersMore'
                },
                component: () =>
                    import('@/views/userList/MemberUsersMore.vue')
            },
            {
                path: '/MemberBanner',
                name: 'MemberBanner',
                meta: {
                    requiredPermission: 'MemberBanner'
                },
                component: () =>
                    import('@/views/MemberBanner/MemberBanner.vue')
            },
            {
                path: '/MemberActivity',
                name: 'MemberActivity',
                meta: {
                    requiredPermission: 'MemberActivity'
                },
                component: () =>
                    import('@/views/MemberActivity/MemberActivity.vue')
            },
            {
                path: '/RoomManage',
                name: 'RoomManage',
                meta: {
                    requiredPermission: 'RoomManage'
                },
                component: () =>
                    import('@/views/RoomManage/RoomManage.vue')
            },
            {
                path: '/ProductManage',
                name: 'ProductManage',
                meta: {
                    requiredPermission: 'ProductManage'
                },
                component: () =>
                    import('@/views/ProductManage/ProductManage.vue')
            },
            {
                path: '/SystemSetting',
                name: 'SystemSetting',
                meta: {
                    requiredPermission: 'SystemSetting'
                },
                component: () =>
                    import('@/views/SystemSetting/SystemSetting.vue')
            },
            {
                path: '/ReserveList',
                name: 'ReserveList',
                meta: {
                    requiredPermission: 'ReserveList'
                },
                component: () =>
                    import('@/views/ReserveList/ReserveList.vue')
            },
            {
                path: '/WalletList',
                name: 'WalletList',
                meta: {
                    requiredPermission: 'WalletList'
                },
                component: () =>
                    import('@/views/WalletList/WalletList.vue')
            },
            {
                path: '/ActivityDetails',
                name: 'ActivityDetails',
                meta: {
                    requiredPermission: 'ActivityDetails'
                },
                component: () =>
                    import('@/views/ActivityDetails/ActivityDetails.vue')
            },
            {
                path: '/LockdownList',
                name: 'LockdownList',
                meta: {
                    requiredPermission: 'LockdownList',
                    // noAuth: true
                },
                component: () =>
                    import('@/views/LockdownList/LockdownList.vue')
            },
        ],
    },

    // ⭐ 必须放在最后，否则乱跳到 404
    {
        path: '*',
        name: '404',
        meta: {
            noAuth: true
        },
        component: () =>
            import('@/views/error-page/404.vue')
    },
];


const router = new VueRouter({
    mode: "history",
    linkActiveClass: "active",
    base: process.env.BASE_URL,
    scrollBehavior: () => ({
        y: 0
    }),
    routes,
});

router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem("token");
    const userid = sessionStorage.getItem("userid");
    const userPermissions = JSON.parse(sessionStorage.getItem('authInfo') || '[]');

    // 1 不需要登录的页面
    if (to.meta.noAuth) {
        return next();
    }

    // 2 未登录 → login
    if (!token || !userid) {
        return next({
            name: "login"
        });
    }

    // 3 已登录访问 login → 跳首页（你后面根路由会跳权限页）
    if (to.name === "login") {
        return next('/home');
    }

    // 4 权限判断
    const requiredPermission = to.meta.requiredPermission;
    if (requiredPermission && !userPermissions.includes(requiredPermission)) {
        return next({
            name: "401"
        });
    }

    next();
});

export default router;